import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { useUser } from './useUser';

export function useOnboarding() {
  const { user } = useAuth();
  const { selectedPlayer, userTeamId, isLoading } = useUser();
  const [needsOnboarding, setNeedsOnboarding] = useState(false);
  const [onboardingComplete, setOnboardingComplete] = useState(false);
  const [isCheckingOnboarding, setIsCheckingOnboarding] = useState(false);
  const [minLoadingTime, setMinLoadingTime] = useState(true);

  // Ensure minimum loading time to prevent flash
  useEffect(() => {
    const timer = setTimeout(() => {
      setMinLoadingTime(false);
    }, 1000); // Minimum 1 second loading time

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Show checking state while user data loads OR during minimum loading time
    if (isLoading || minLoadingTime) {
      setIsCheckingOnboarding(true);
      setNeedsOnboarding(false);
      return;
    }

    // If no user is logged in, no onboarding needed
    if (!user) {
      setIsCheckingOnboarding(false);
      setNeedsOnboarding(false);
      return;
    }

    // If user has already completed onboarding in this session, don't show again
    if (onboardingComplete) {
      setIsCheckingOnboarding(false);
      setNeedsOnboarding(false);
      return;
    }

    // Now we can safely check if onboarding is needed
    const missingPlayer = !selectedPlayer;
    const missingTeam = !userTeamId;
    
    setIsCheckingOnboarding(false);
    setNeedsOnboarding(missingPlayer || missingTeam);
  }, [user, selectedPlayer, userTeamId, isLoading, onboardingComplete, minLoadingTime]);

  const completeOnboarding = () => {
    setOnboardingComplete(true);
    setNeedsOnboarding(false);
  };

  return {
    needsOnboarding,
    isCheckingOnboarding,
    completeOnboarding,
  };
}